import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Spinner from "@/components/Spinner";

/**
 * Intermediate page that handles Stripe onboarding callbacks.
 * Stripe requires valid HTTPS URLs, so this page receives the callback
 * and redirects mobile users back to the native app via deep link.
 */
const StripeCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const isMobile = searchParams.get("mobile") === "true";
    const stripeOnboarding = searchParams.get("stripe_onboarding");
    const stripeRefresh = searchParams.get("stripe_refresh");

    // Build the dashboard URL with Stripe params
    const dashboardParams = new URLSearchParams({ tab: "earnings" });
    if (stripeOnboarding) {
      dashboardParams.set("stripe_onboarding", stripeOnboarding);
    }
    if (stripeRefresh) {
      dashboardParams.set("stripe_refresh", stripeRefresh);
    }

    if (isMobile) {
      // Redirect to native app via deep link
      const deepLinkUrl = `com.peespees.giftmap://dashboard?${dashboardParams.toString()}`;
      console.log("Redirecting to native app:", deepLinkUrl);
      window.location.href = deepLinkUrl;
    } else {
      // Stay on web, redirect to dashboard
      navigate(`/dashboard?${dashboardParams.toString()}`, { replace: true });
    }
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Spinner size={32} />
        <p className="text-muted-foreground">Completing setup...</p>
      </div>
    </div>
  );
};

export default StripeCallback;
